var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuseumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98438 0.984375L19.5 6V8.01562H0.515625V6L9.98438 0.984375ZM14.4844 9.98438H17.4844V17.0156H14.4844V9.98438ZM0.515625 21.9844V18.9844H19.5V21.9844H0.515625ZM8.48438 9.98438H11.4844V17.0156H8.48438V9.98438ZM2.48438 9.98438H5.48438V17.0156H2.48438V9.98438Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuseumIcon);
export default __webpack_public_path__ + "static/media/museum_icon.3e7b76bae81b39534a1f69681b0d0d4a.svg";
export { ForwardRef as ReactComponent };